/* This file was generated automatically. Do not edit manually. */

export enum EnterpriseScopeCounterDiscriminator {
    AccountingCounter = 'AccountingCounter',
    AvailabilityBlockCounter = 'AvailabilityBlockCounter',
    BillCounter = 'BillCounter',
    BillPreviewCounter = 'BillPreviewCounter',
    FiscalCounter = 'FiscalCounter',
    ProformaCounter = 'ProformaCounter',
    RegistrationCardCounter = 'RegistrationCardCounter',
    ServiceOrderCounter = 'ServiceOrderCounter',
    CorrectionBillCounter = 'CorrectionBillCounter',
    PaymentConfirmationBillCounter = 'PaymentConfirmationBillCounter',
    CreditNoteBillCounter = 'CreditNoteBillCounter',
}
